module.exports = __webpack_public_path__ + "static/img/CStu10@2x.90192f46.png";